import React, { Component } from 'react';

import './serviceFee.scss';

// Container fixed buat semua banner warning (MSF + Marketing Balance).
// Tinggi banner variatif (teks IT lebih panjang, mobile wrap) → ukur beneran pakai
// ResizeObserver, tulis ke --banners-total; header/sidebar/konten ngikut nilai itu.
class GlobalBannerStack extends Component{
  constructor(props){
    super(props);
    this.stackRef = React.createRef();
  }

  componentDidMount(){
    this.observer = new ResizeObserver(() => this.syncHeight());
    if(this.stackRef.current){
      this.observer.observe(this.stackRef.current);
    }
    this.syncHeight();
  }

  componentDidUpdate(){
    this.syncHeight();
  }

  componentWillUnmount(){
    if(this.observer){
      this.observer.disconnect();
    }
    document.documentElement.style.removeProperty('--banners-total');
    document.body.classList.remove('has-banners');
  }

  syncHeight(){
    const height = this.stackRef.current ? this.stackRef.current.offsetHeight : 0;
    document.documentElement.style.setProperty('--banners-total', `${height}px`);
    document.body.classList.toggle('has-banners', height > 0);
  }

  render(){
    return(
      <div className="banner-stack" ref={this.stackRef}>
        {this.props.children}
      </div>
    );
  }
}

export default GlobalBannerStack;
